import { ArrowLeftIcon, CopyIcon } from '@phosphor-icons/react';

import { Button } from '@/ui/button/Button';

/**
 * The merge direction, written the way the providers write it: `base ← head`, target first.
 */
export function BranchPair({ base, head, onCopyHead }: { base: string; head: string; onCopyHead?: () => void }) {
  return (
    <span className="flex min-w-0 items-center gap-1.5 text-xs text-fg-secondary">
      <span className="truncate text-fg-tertiary">{base}</span>
      <ArrowLeftIcon size={10} className="shrink-0 text-fg-tertiary" />
      <span className="truncate">{head}</span>
      {onCopyHead && (
        <Button variant="ghost" shape="square" size={7} onClick={onCopyHead} aria-label={`Copy branch name ${head}`}>
          <CopyIcon size={12} />
        </Button>
      )}
    </span>
  );
}
